import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PhoneLink, SectionHeading, WhatsAppButton } from "../home/CtaButtons";
import { FaqItems } from "../faq/FaqItems";

export const FaqMoreLink = ({ testid }) => (
  <Link to="/veelgestelde-vragen" className="inline-flex items-center gap-1.5 text-[14.5px] font-semibold text-maas hover:underline" data-testid={testid}>
    Alle veelgestelde vragen <ArrowRight className="h-4 w-4" aria-hidden="true" />
  </Link>
);

// Vragen komen uit het centrale FAQ-beheer; zonder gekoppelde vragen verschijnt het blok niet.
export const ProductFAQ = ({ faqs, title, eyebrow = "Veelgestelde vragen" }) => {
  if (!faqs?.length) return null;
  return (
    <section id="vragen" aria-labelledby="vragen-title" className="section scroll-mt-12" data-testid="product-faq">
      <div className="container-tight grid gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <SectionHeading id="vragen-title" eyebrow={eyebrow} title={title}
            lead="Staat uw vraag er niet bij? Stel hem gerust via WhatsApp of bel ons." />
          <div className="mt-6 flex flex-col items-start gap-4">
            <WhatsAppButton location="product-faq" />
            <PhoneLink location="product-faq" />
            <FaqMoreLink testid="product-faq-all-link" />
          </div>
        </div>
        <div className="lg:col-span-8"><FaqItems faqs={faqs} testid="product-faq-item" /></div>
      </div>
    </section>
  );
};
